/**
 * Browser-stored values that belong to a **person**, not to a device.
 *
 * Signing out cleared the identity refs and nothing else, so the recent
 * searches stayed in `localStorage`: on a shared laptop, or after a second
 * GitLab account signs in, the next person opened Knowledge and read what the
 * last one had been looking for. Measured in round 39.
 *
 * The colour scheme and the board's column widths deliberately stay. Those
 * describe the screen somebody is sitting at, not the person sitting at it,
 * and wiping them on sign-out would be a worse surprise than keeping them.
 */

/** What somebody typed into Knowledge, newest first. */
export const RECENT_SEARCHES_KEY = "ctf_knowledge_recent";

const PERSONAL_KEYS: readonly string[] = [RECENT_SEARCHES_KEY];

/** Called on sign-out. Storage can throw in a private window, so it is guarded. */
export function clearPersonalStorage(): void {
  for (const key of PERSONAL_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // A browser that refuses storage has nothing to clear.
    }
  }
}
